import { useEffect } from "react";
import { BehaviorSubject } from "rxjs";

export const DEFAULT_TITLE = "OM Platform";
export const subjectTitle = new BehaviorSubject(DEFAULT_TITLE);

export default function useSetTitle(title) {
  useEffect(() => {
    subjectTitle.next(title);

    return () => subjectTitle.next(DEFAULT_TITLE);
  }, [title]);
}
